/**
 * Project Configuration
 * =====================
 * Customize these values for your project.
 * All metadata, URLs, and branding should be configured here.
 */

export const projectName = "ANSV";
export const url = "https://your-project.seguridadvial.gob.ar";
export const logo = "/img/portal_ansv.svg";
export const logoLeyend = "/img/logos-sv-st-blanco.svg";
export const defaultLocale = "es";
export const gtag = "G-XXXXXXXXXX"; // TODO: Replace with actual Google Analytics ID
export const keywords: string[] = [];
export const pageLimit = 10;

export const defaultMetadata = {
  title: "ANSV - Tu Proyecto",
  description: "Descripción de tu proyecto ANSV",
  keywords,
  openGraph: {
    title: "ANSV - Tu Proyecto",
    description: "Descripción de tu proyecto ANSV",
    url,
    siteName: projectName,
    images: [
      {
        url: logo,
        width: 1200,
        height: 630,
        alt: projectName
      }
    ],
    locale: "es_AR",
    type: "website"
  },
  twitter: {
    card: "summary_large_image",
    title: "ANSV - Tu Proyecto",
    description: "Descripción de tu proyecto ANSV",
    images: [logo]
  }
};

export const socialLinks = {
  facebook: "https://www.facebook.com/infosegvial",
  instagram: "https://www.instagram.com/Infosegvial",
  linkedin: "https://www.linkedin.com/in/agencia-nacional-de-seguridad-vial",
  twitter: "https://x.com/ansv_ar",
  youtube: "https://www.youtube.com/WebANSV"
};

export const contactEmail = "info@ansv.gob.ar";
